import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as styles from './style.css';
import { createClassNames } from "../../../../infrastructure/helpers";

const stylesThemeMap = {
  white: {
    touchable: styles.btnWhiteTouchable,
    text: styles.btnWhiteText
  },
  whiteDarkText: {
    touchable: styles.btnWhiteDarkTextTouchable,
    text: styles.btnWhiteDarkTextText
  },
  brand: {
    touchable: styles.btnBrandTouchable,
    text: styles.btnBrandText
  },
  whiteBrand: {
    touchable: styles.btnWhiteBrandTouchable,
    text: styles.btnWhiteBrandText
  },
  danger: {
    touchable: styles.btnDangerBrandTouchable,
    text: styles.btnDangerText
  },
  whiteDanger: {
    touchable: styles.btnWhiteDangerBrandTouchable,
    text: styles.btnWhiteDangerText
  },
  memorial: {
    touchable: styles.btnMemorialTouchable,
    text: styles.btnMemorialText
  },
};

class UQButton extends PureComponent {

  static defaultProps = {
    theme: 'brand',
    onPress: () => {}
  };

  static propTypes = {
    theme: PropTypes.oneOf(['white', 'whiteDarkText', 'whiteBrand', 'brand', 'danger', 'memorial']),
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    containerClass: PropTypes.string,
    containerStyle: PropTypes.object,
    innerClass: PropTypes.string,
    textClass: PropTypes.string,
    onPress: PropTypes.func,
    icon: PropTypes.element,
    notPressOpacity: PropTypes.bool,
    iconWrapStyles: PropTypes.string,
    justIcon: PropTypes.bool
  };

  _onPress = ($event) => {
    $event.preventDefault();
    this.props.onPress($event);
  };

  render() {
    const themeStyles = stylesThemeMap[this.props.theme];
    const btnStylesArr = [styles.btnCommonTouchable, themeStyles.touchable, this.props.containerClass];
    const textStylesArr = [styles.btnCommonText, themeStyles.text, this.props.textClass];
    let innerStyles = createClassNames([styles.btnCommonInner, this.props.innerClass]);
    const iconWrapStylesArr = [styles.btnCommonIconWrap, this.props.iconWrapStyles];

    if (this.props.disabled) {
      btnStylesArr.push(styles.btnDisabledTouchable);
      textStylesArr.push(styles.btnDisabledText);
    }

    if (this.props.notPressOpacity) {
      btnStylesArr.push(styles.btnNotOpacity);
    }

    if (this.props.justIcon) {
      iconWrapStylesArr.push(styles.btnCommonIconWrapCenter)
    }

    const btnStyles = createClassNames(btnStylesArr);
    const textStyles = createClassNames(textStylesArr);
    const iconWrapStyles = createClassNames(iconWrapStylesArr);
    return (
      <button type="button"
              className={btnStyles}
              disabled={this.props.disabled}
              style={this.props.containerStyle}
              onClick={this._onPress}>
        <div className={innerStyles}>
          { this.props.icon && (
            <div className={iconWrapStyles}>{this.props.icon}</div>
          ) }
          {!this.props.justIcon && (
            <div className={textStyles}>
              { this.props.label }
            </div>
          )}

        </div>
      </button>
    );
  }
}

export default UQButton;



// WEBPACK FOOTER //
// ./src/app/modules/uq-ui/components/button/index.jsx